import i18n from './i18n';

export default i18n;
export * from './i18n';
export * from './utils';
export * from './types';
